import styled, { css } from 'styled-components';
import { Row, Col } from '@/components/grid/grid-component';
import { Heading3Text, BodyText } from '@/utils/global-fonts';
import { GoCircle } from 'react-icons/go';
import Card from '@/components/card/card-component';

const Wrapper = styled(Row)`
  width: 100%;
  width: 100%;
  padding-left: 32px;
`;

const SideCol = styled(Col)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Header = styled(Heading3Text)`
  font-size: 16px;
  width: 100%;
`;

const StatusCircle = styled(GoCircle)`
  margin-left: 8px;
  ${(props) => {
    switch (props.status) {
      case 'active':
        return css`
          color: ${props.theme.COLOR_STATUS_GREEN};
        `;
      case 'new':
        return css`
          color: ${props.theme.COLOR_STATUS_BLUE};
        `;
      case 'suspended':
        return css`
          color: ${props.theme.COLOR_STATUS_ORANGE};
        `;
      default:
        return null;
    }
  }}
`;

const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  border-radius: 4px 4px 0px 0px;
  min-height: 100px;
`;
const GalleryWrapper = styled(SectionWrapper)``;
const CategoryWrapper = styled(SectionWrapper)``;
const DocumentUploadWrapper = styled(SectionWrapper)`
  justify-content: space-between;
`;

const UploadContainer = styled(Card)`
  margin-top: 16px;
  border-radius: 4px 4px 0px 0px;
`;
const CategoryContainer = styled(Card)`
  border-radius: 4px 4px 0px 0px;
`;

const ActionArea = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  height: 65px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-radius: 0px 0px 4px 4px;
  background-color: ${({ theme }) => theme.COLOR_BG_LIGHT};
`;

const ActionText = styled(BodyText)`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
  text-align: left;
  text-vertical-align: middle;
`;

const DocumentAction = styled.div``;

const ActionsContainer = styled.div`
  padding: ${({ noPadding }) => (noPadding ? '0px' : '30px')};
`;

const ExtraActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.COLOR_BG_LIGHT};
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  height: 56px;
  padding-left: 15px;
  padding-right: 15px;
`;

const LeftActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 13px 0 0;
`;

const RightActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const styledForm = {
  Wrapper,
  Header,
  StatusCircle,
  GalleryWrapper,
  ActionWrapper,
  UploadContainer,
  CategoryContainer,
  ActionArea,
  SideCol,
  CategoryWrapper,
  ActionText,
  DocumentUploadWrapper,
  DocumentAction,
  ActionsContainer,
  ExtraActionsWrapper,
  LeftActionsWrapper,
  RightActionsWrapper,
};

export default styledForm;
